/**
 * Handles the blur event on an input dropdown.
 * @param {string} dropdownContainerSelector - The attribute of the dropdown container e.g. '.new-input__dropdown-container'.
 * @param {string} inputFieldSelector - The attribute of the input field. e.g. '#store'.
 */
export function handleCloseInputDropdownOnBlur(
    dropdownContainerSelector,
    inputFieldSelector,
) {
    window.addEventListener('click', (event) => {
        const dropdownParent = document.querySelector(
            dropdownContainerSelector,
        );
        const dropdown = document.querySelector('.dropdown__options-holder');
        const inputField = document.querySelector(inputFieldSelector);

        if (!dropdownParent || !dropdown || !inputField) return;

        const isInputEmpty = inputField.value.length === 0;
        const isClickInsideDropdown = dropdown.contains(event.target);
        const isClickInsideDropdownParent = dropdownParent.contains(
            event.target,
        );

        if (isClickInsideDropdownParent && !isInputEmpty) {
            dropdownParent.classList.add('dropdown-active');
            return;
        }

        if (isClickInsideDropdown || isClickInsideDropdownParent) {
            return;
        }

        dropdownParent.classList.remove('dropdown-active');
    });
}
